import Region from "../Region";
import RegionArea from "../RegionArea";
import Phaser from 'phaser';

import * as ABCya from '@abcya/abcya_phaser';
import UIAssetKeys from '../UIAssetKeys';
import { AREAS, SHAPES } from '../gameData';

export default class TentArea extends RegionArea
{
    /**
     * @param {Region} region the owner region
     */
    constructor(parentRegion)
    {
        super(parentRegion, AREAS[parentRegion.region].TENT);

        this._createArea();

        this.reset();
    }

    /**
     * Reset should be called when you want to set the state to a disabled/inactive state.
     */
    reset()
    {
        super.reset();

        this.tentSide.setAlpha(0);
        this.tentFront.setAlpha(0);
        this.fullTent.setAlpha(0);
    }

    /**
     * Prepare should be called before you want to prepare the state to become active.
     */
    prepare()
    {
        super.prepare();

        this.tentSide.disableInteractive();
        this.tentFront.disableInteractive();
        this.fullTent.disableInteractive();
    }

    /**
     * Send all game objects to their start positions.
     */
    _sendObjectsToStartPositions()
    {
        super._sendObjectsToStartPositions();

        this.tentSide.setAlpha(0.000001);
        this.tentFront.setAlpha(0.000001);
        this.fullTent.setAlpha(0.000001);
    }

    /**
     * Creates the area, by adding the overlays to the parent region and creates the area information sidebar.
     */
    _createArea()
    {
        let tentSideHitArea = new Phaser.Geom.Polygon(
            [
                { x: 136, y: 467 },
                { x: 0, y: 155 },
                { x: 271, y: 0 },
                { x: 406, y: 312 },
            ]);
        this.tentSide = ABCya.Images.addImage(749, 382, UIAssetKeys._10_Camping_Zoom_In_Tent_Slct_TntSide, this.parentRegion).setInteractive(tentSideHitArea, Phaser.Geom.Polygon.Contains);
        this.tentSide.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.tentSide, SHAPES.SQUARE);
        });

        let tentFrontHitArea = new Phaser.Geom.Polygon(
            [
                { x: 273, y: 313 },
                { x: 0, y: 156 },
                { x: 137, y: 0 },
            ]);
        this.tentFront = ABCya.Images.addImage(548, 460, UIAssetKeys._10_Camping_Zoom_In_Tent_Slct_TntFrnt, this.parentRegion).setInteractive(tentFrontHitArea, Phaser.Geom.Polygon.Contains);
        this.tentFront.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.tentFront, SHAPES.TRIANGLE);
        });

        let fullTentHitArea = new Phaser.Geom.Polygon(
            [
                { x: 269, y: 467 },
                { x: 0, y: 310 },
                { x: 135, y: 157 },
                { x: 402, y: 0 },
                { x: 539, y: 311 },
            ]);
        this.fullTent = ABCya.Images.addImage(683, 382, UIAssetKeys._10_Camping_Zoom_In_Tent_Slct_TrnglrPrsm, this.parentRegion).setInteractive(fullTentHitArea, Phaser.Geom.Polygon.Contains);
        this.fullTent.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.fullTent, SHAPES.TRIANGULAR_PRISM);
        });

        this.shapeOverlays[SHAPES.SQUARE] = [this.tentSide];
        this.shapeOverlays[SHAPES.TRIANGLE] = [this.tentFront];
        this.shapeOverlays[SHAPES.TRIANGULAR_PRISM] = [this.fullTent];

        this._createAreaInformation(0x5f5fd6, 0x204243);
    }

    /**
     * Zoom into the area.
     */
    zoomIn()
    {
        let tweens = super.zoomIn();

        tweens.push(
            {
                targets: [
                    this.parentRegion.treeAreaContainer, this.parentRegion.truck, this.parentRegion.chair
                ],
                duration: 500,
                props: { alpha: 0 },
                ease: Phaser.Math.Easing.Quadratic.Out,
            },
            { targets: this.parentRegion.tent, duration: 1000, props: { scale: 1, x: 682, y: 383 }, ease: Phaser.Math.Easing.Quadratic.Out, offset: 0 },
            { targets: this.areaInformation, duration: 500, props: { x: this.areaInformation.onScreenPosition.x }, ease: Phaser.Math.Easing.Back.Out, offset: 500 }
        );

        return tweens;
    }

    /**
     * Zoom out of the area.
     */
    zoomOut()
    {
        let tweens = super.zoomOut();

        this.tentSide.disableInteractive();
        this.tentFront.disableInteractive();
        this.fullTent.disableInteractive();

        for (let shape in this.shapeOverlays)
        {
            // fade off the overlay
            tweens.push(
                {
                    targets: this.shapeOverlays[shape],
                    duration: 500,
                    props: { alpha: 0 },
                    ease: Phaser.Math.Easing.Quadratic.Out,
                    offset: 0
                }
            );
        }

        tweens.push(
            { targets: this.areaInformation, duration: 500, props: { x: this.areaInformation.offScreenPosition.x }, ease: Phaser.Math.Easing.Back.In, offset: 0 },
            { targets: this.parentRegion.tent, duration: 1000, props: { scale: .4109, x: this.parentRegion.tent.onScreenPosition.x, y: this.parentRegion.tent.onScreenPosition.y }, ease: Phaser.Math.Easing.Quadratic.Out, offset: 250 },
            { targets: [this.parentRegion.chair, this.parentRegion.truck, this.parentRegion.treeAreaContainer], duration: 500, props: { alpha: 1 }, ease: Phaser.Math.Easing.Quadratic.Out, offset: 500 },
        );

        return tweens;
    }
}